import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function TransformationSection() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const benefits = ['crear un producto desde cero', 'entender qué vender y cómo estructurarlo', 'configurar Shopify correctamente', 'crear tu tienda paso a paso', 'conectar dominio', 'vincular Mercado Pago', 'configurar Meta Business y cuentas publicitarias', 'instalar y configurar pixel', 'entender la estructura básica de campañas', 'usar IA para avanzar más rápido con contenido, copy e ideas', 'lanzar una estructura real para empezar a generar ventas'];
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-331">
      <div className="max-w-5xl mx-auto" data-id="element-332">
        <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-12 text-center leading-tight" data-id="element-333">
          ¿Qué vas a lograr con Dominando Shopify?
        </h2>

        <div className="bg-gradient-to-br from-blue-50 to-green-50 rounded-2xl p-8 md:p-12 mb-8" data-id="element-334">
          <p className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-center" data-id="element-335">
            Con este programa vas a aprender a:
          </p>

          <div className="space-y-4" data-id="element-336">
            {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-4 bg-white rounded-lg p-4 shadow-sm" data-id="element-337">
                <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-338" />
                <span className="text-lg text-gray-700" data-id="element-339">{benefit}</span>
              </div>)}
          </div>
        </div>

        <div className="bg-gray-900 text-white rounded-2xl p-8 md:p-12 text-center" data-id="element-340">
          <p className="text-xl md:text-2xl font-bold mb-4" data-id="element-341">
            No prometemos magia.
          </p>
          <p className="text-2xl md:text-3xl font-black text-green-400" data-id="element-342">
            Prometemos claridad, estructura y dirección.
          </p>
        </div>

        <div className="text-center mt-12" data-id="element-343">
          <CTAButton text="QUIERO ACCEDER AL PROGRAMA" onClick={scrollToCompra} size="large" data-id="element-344" />
        </div>
      </div>
    </section>;
}